import type { SvgIconComponent } from '@mui/icons-material';
import type { InputHTMLAttributes } from 'react';
import type { FieldValues, Path, RegisterOptions, UseFormRegister } from 'react-hook-form';

interface NumberInputProps<T extends FieldValues> extends InputHTMLAttributes<HTMLInputElement> {
  register: UseFormRegister<T>;
  registerName: Path<T>;

  label?: string;
  registerProps?: RegisterOptions<T, Path<T>>;
  isSecondary?: boolean;
  isDisabled?: boolean;
  error?: FieldValues['errors'];
  placeholder?: string;
  icon?: SvgIconComponent;
}

export const NumberInput = <T extends FieldValues>({
  label,
  register,
  registerName,
  registerProps,
  isSecondary,
  isDisabled,
  error,
  placeholder,
  icon: Icon,
  ...rest
}: NumberInputProps<T>) => {
  return (
    <div>
      {label && (
        <label htmlFor={registerName} className="mb-1 text-sm">
          {label}
        </label>
      )}
      <div
        className={`flex items-center pl-2 py-1 rounded-md focus-within::outline-none focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent ${
          isDisabled ? 'bg-gray-200' : isSecondary ? 'bg-secondary border-1 border-secondary-light' : 'bg-transparent border-1 border-primary'
        }`}>
        {Icon && <Icon className="text-primary" />}
        <input
          {...rest}
          type="number"
          id={registerName}
          className="w-full h-full p-2 bg-transparent focus:outline-none"
          {...register(registerName, registerProps)}
          disabled={isDisabled}
          placeholder={placeholder}
        />
      </div>
      {error && <span className="text-xs text-red-500">{error.message}</span>}
    </div>
  );
};
